import Vue from 'vue'
import Vuex from 'vuex'
import router from './router';
import api from './api/admin';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: null,
    loggingIn: false,
    loginError: null
  },
  mutations: {
    loginStart: state => state.loggingIn = true,
    loginStop: (state, errorMessage) => {
      state.loggingIn = false;
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    logout: (state) => {
      state.accessToken = null;
    }
  },
  actions: {
    doLogin({ commit }, loginData) {
      commit('loginStart');
      api.login(loginData)
        .then(response => {
          console.log(response)
          localStorage.setItem('accessToken', response.data.data.token);
          localStorage.setItem('id', response.data.data.id);
          localStorage.setItem('name', response.data.data.name);
          localStorage.setItem('avatar', response.data.data.avatar);
          localStorage.setItem('npp', response.data.data.npp);
          localStorage.setItem('user_role_id', response.data.data.user_role_id);
          localStorage.setItem('relation_code', response.data.data.relation_code);
          commit('loginStop', null);
          commit('updateAccessToken', response.data.data.token);
          if (response.data.data.user_role_id == 2) {
            router.replace('/employees');
          } else {
            router.replace('/');
          }
        })
        .catch(error => {
          // console.log(error.response.data)
          commit('loginStop', error.response.data.message);
          commit('updateAccessToken', null);
        })
    },
    fetchAccessToken({ commit }) {
      commit('updateAccessToken', localStorage.getItem('accessToken'));
    },
    logout({ commit }) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('id');
      localStorage.removeItem('name');
      localStorage.removeItem('npp');
      localStorage.removeItem('user_role_id');
      localStorage.removeItem('relation_code');
      commit('logout');
      router.replace('/login');
    }
  }
})